import groq from 'groq';
import { CONTENT_BLOCK_GROUP_PROJECTION } from '@/integrations/sanity/api/projections';
import { sanityFetch } from '@/integrations/sanity/client';
import type { SEKKI_QUERY_RESULT } from '@/integrations/sanity/sanity.types';

const SEKKI_QUERY = groq`*[_type == "sekkiContent"][0] {
  id,
  _type,
  contentBlockGroup ${CONTENT_BLOCK_GROUP_PROJECTION} 
}`;

export const getSekki = () => sanityFetch<SEKKI_QUERY_RESULT>(SEKKI_QUERY);
